import { api } from '../../lib/api';
import { T, useGym } from '../../lib/gym';
import { useApi } from '../../lib/hooks';
import { useI18n } from '../../lib/i18n';
import { Badge, Card, Checkbox, Empty, ErrorBox, Loading, PageHeader, useToast } from '../../ui/components';

/** Today's opening and closing rounds, ticked off by whoever is in. */
export function ChecklistsPage() {
  const gym = useGym();
  const i18n = useI18n();
  const toast = useToast();
  const lists = useApi(() => api<any[]>(`${T(gym.slug)}/admin/checklists/today`), []);

  const toggle = async (list: any, item: string, on: boolean): Promise<void> => {
    const ticks = on ? [...list.ticks, item] : list.ticks.filter((t: string) => t !== item);
    const r = await api(`${T(gym.slug)}/admin/checklists/${list.id}/tick`, { body: { ticks } });
    if (r.complete) toast.ok(i18n.t('checklists.complete', { name: list.name }));
    lists.reload();
  };

  if (lists.error) return <div className="page"><ErrorBox error={lists.error} onRetry={lists.reload} /></div>;
  if (!lists.data) return <Loading />;

  return (
    <div className="page">
      <PageHeader title={i18n.t('checklists.title')} subtitle={i18n.t('checklists.subtitle')} />
      {lists.data.length === 0 ? <Empty icon="✓">{i18n.t('checklists.none')}</Empty> : lists.data.map((list) => (
        <Card key={list.id} title={list.name} actions={
          list.completedAt
            ? <Badge value="done" label={i18n.t('checklists.done_at', { time: i18n.time(list.completedAt) })} />
            : <span className="small muted">{list.done}/{list.total}</span>
        }>
          <div className="stack-sm">
            {list.items.map((item: string) => (
              <Checkbox key={item} label={item} checked={list.ticks.includes(item)} onChange={(on) => toggle(list, item, on)} />
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}
